module.exports = __webpack_public_path__ + "assets/deleteFile.415d4f01afe58987f46bac5de9d61981.png";